import api from './api';

const milestoneService = {
  // Get all milestones with optional filters
  getAllMilestones: async (params = {}) => {
    const response = await api.get('/milestones', { params });
    return response.data;
  },

  // Get milestone by ID
  getMilestoneById: async (id) => {
    const response = await api.get(`/milestones/${id}`);
    return response.data;
  },

  // Create new milestone
  createMilestone: async (milestoneData) => {
    const response = await api.post('/milestones', milestoneData);
    return response.data;
  },

  // Update milestone
  updateMilestone: async (id, milestoneData) => {
    const response = await api.put(`/milestones/${id}`, milestoneData);
    return response.data;
  },

  // Delete milestone
  deleteMilestone: async (id) => {
    const response = await api.delete(`/milestones/${id}`);
    return response.data;
  },

   submitMilestoneResourceAvailability: async (payload) => {
    const response = await api.post('/resource-allocations/milestonesResourceAvailability', payload);
    return response.data;
  },
};

export default milestoneService;


